// ADDED
import { useState, useCallback, useEffect } from "react";
import offsetService from "../services/offsetService";
import { useGeneralMessage } from "../../common/APICommon";

export const useOffsetRequest = (user) => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const [formData, setFormData] = useState({
    employeeId: user.employeePersonalInformationId,
    employeeName: user.employeePersonalInformationFullName,
    type: "Overtime",
    reason: "",
    content: null,
    fileName: "",
    // Overtime Specific
    referenceDate: null,
    date: "",
    hours: 0,
    // Leave Specific
    reference: null,
    dateFrom: "",
    dateTo: "",
    days: 0
  });

  const fetchHistory = useCallback(async () => {
    if (!formData.employeeId) return;
    try {
      setLoading(true);
      const res = await offsetService.getByEmployee(formData.employeeId);
      setRequests(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [formData.employeeId]);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSelectEmployee = (emp) => {
    setFormData(prev => ({
      ...prev,
      employeeId: emp.id,
      employeeName: emp.fullName,
      referenceDate: null,
      reference: null
    }));
  };

  const submitRequest = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const payload = {
        employeePersonalInformationId: formData.employeeId,
        requestTypeId: 5,
        reason: formData.reason,
        status: "Sent",
        dateRequested: new Date().toISOString(),
        content: formData.content,
        type: formData.type,
        // OT Logic
        referenceDate: formData.type === "Overtime" ? formData.referenceDate?.date : null,
        date: formData.type === "Overtime" ? formData.date : null,
        hours: formData.type === "Overtime" ? parseFloat(formData.hours) : 0,
        // Leave Logic
        referenceId: formData.type === "Leave" ? formData.reference?.leaveData?.id : null,
        dateFrom: formData.type === "Leave" ? formData.dateFrom : null,
        dateTo: formData.type === "Leave" ? formData.dateTo : null,
        days: formData.type === "Leave" ? parseFloat(formData.days) : 0,
      };

      const res = await offsetService.create(payload);
      const createdRequest = res.data;

      // 2. Create Approval
      await offsetService.createApproval({
        requestId: createdRequest.id,
        requestTypeId: 5,
        primaryApproverStatus: "Pending",
        secondaryApproverStatus: "Pending",
        tertiaryApproverStatus: "Pending"
      });

      // 3. SMS Notification (Async non-blocking)
      triggerSmsNotifications(createdRequest);

      showGeneralMessage("Offset request submitted successfully!", true);
      fetchHistory();
      return true;
    } catch (err) {
      showGeneralMessage(err.response?.data?.message || "Failed to submit", false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const triggerSmsNotifications = async (request) => {
    try {
      const hierarchy = await offsetService.getApproverHierarchy(formData.employeeId);
      // logic to extract unique contacts and call offsetService.sendSmsNotification
      // follows legacy phone formatting logic...
    } catch (e) { console.error("SMS Error", e); }
  };

  return {
    loading, requests, formData, handleInputChange,
    handleSelectEmployee, submitRequest, showMessage, message, isSuccess
  };
};